<template>
  <div>
    <div class="choose">
      <van-cell-group @click.native="isYearShow=true">
        <van-field label="学年" placeholder="请选择学年" readonly v-model='selectYear' />
      </van-cell-group>
      <van-cell-group @click.native="isSessionShow=true">
        <van-field label="学期" placeholder="请选择学期" readonly v-model='selectSession' />
      </van-cell-group>
      <van-cell-group @click.native="isStatusShow=true">
        <van-field label="状态" placeholder="请选择状态" readonly v-model='selectStatus' />
      </van-cell-group>
      <van-action-sheet v-model="isYearShow" :actions="yearData" @select="yearSelectFun" cancel-text="取消"
        close-on-click-action />
      <van-action-sheet v-model="isSessionShow" :actions="sessionData" @select="sessionSelectFun" cancel-text="取消"
        close-on-click-action />
      <van-action-sheet v-model="isStatusShow" :actions="statusData" @select="statusSelectFun" cancel-text="取消"
        close-on-click-action />
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" :offset=10
        @load="loadList">
        <ul class="approval-ul">
          <li class="approval-li clearfix" v-for="item in applyList" :key="item.ID" @click="load(item)">
            <!-- <div style="margin-right:10px;">
                    <img src="/image/yrykb.png" class="img-photo" />
                </div> -->
                <div style="flex:1">
                    <h3 class="class-name" v-cloak>{{item.CreateName}}提交的{{item.ApplyTypeName}}申请</h3>
                    <h3 class="effective-week" v-cloak>班级：{{item.StudentOrganizationFullName}}</h3>
                    <p class="adjust-type" v-cloak>{{item.CreateByDate?item.CreateByDate.split('T')[0]:''}}</p>
                </div>
                <div class="status-type">
                    <div style="color:#E8A022" v-if="item.SubstituteStatus === 0">未审批</div>
                    <div style="color:#E8A022" v-if="item.SubstituteStatus === 1">审批中</div>
                    <div style="color:#21A83E" v-if="item.SubstituteStatus === 2">已通过</div>
                    <div style="color:#D83737" v-if="item.SubstituteStatus === 3">已拒绝</div>
                    <div style="color:#D83737" v-if="item.SubstituteStatus === 4">已撤销</div>
                    <div style="color:#D83737" v-if="item.SubstituteStatus === 40">已撤回</div>
                </div>
            <!--0申请中 1待审批 2已通过 3未通过 4已拒绝 5已过期 6已撤销 7已撤回-->
            
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { setTimeout } from "timers";
import xyapi from "@/common/api";
export default {
  data() {
    return {
      page: 1,
      pageSize: 15,
      applyList: [],
      loading: false, // 是否加载中
      finished: false, // 加载是否完成
      isLoading: false, //是否处于下拉刷新状态
      //学年
      isYearShow: false,
      selectYear: "",
      selectYearId: 0,
      yearData: [],
      //学期
      isSessionShow: false,
      selectSession: "",
      selectSessionId: 0,
      sessionData: [],
      //状态
      isStatusShow: false,
      selectStatus: "",
      selectStatusId: 0,
      statusData: []
    };
  },
  created() {
    this.getYear();
  },
  mounted() {},
  methods: {
    //审批、查看审批
    load(val) {
      this.$store.commit('csmstimetable/setApplyObj', val)
      this.$router.push('/home/applyRecord');
    },
    //选中学年
    yearSelectFun(e) {
      this.selectYear = e.name;
      this.selectYearId = e.id;
      //选择学年时把联动的学期置空
      this.getSession(e.id);
    },
    // 选中学期
    sessionSelectFun(e) {
      this.selectSession = e.name;
      this.selectSessionId = e.id;
      this.onRefresh();
    },
     // 选中状态
    statusSelectFun(e) {
      this.selectStatus = e.name;
      this.selectStatusId = e.id;
      this.onRefresh();
    },
    //获取学年
    async getYear() {
      this.xy.loading();
      let res = await xyapi.get(`${this.xyMApi}/xy/comm/YearList`);
      this.xy.unloading();
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            if (item.IsCurrent) {
              this.selectYearId = item.ID;
              this.selectYear = item.Name;
              this.getSession(item.ID);
            }
            this.yearData.push({
              id: item.ID,
              name: item.Name
            });
          });
        }
      }
    },
    //获取学期
    async getSession(id) {
      this.xy.loading();
      let res = await xyapi.get(`${this.xyMApi}/xy/comm/SessionList`, {
        yearID: id
      });
      this.xy.unloading();
      if (res.success) {
        this.selectSession = "";
        this.selectSessionId = 0;
        this.sessionData = [];
        res.data.map(item => {
          if (item.IsCurrent) {
            this.selectSessionId = item.AcademicSessionID;
            this.selectSession = item.AcademicSessionName;
          }
          this.sessionData.push({
            id: item.AcademicSessionID,
            name: item.AcademicSessionName
          });
        });
        this.getApprovalFlowStatus();
      }
    },
    //获取状态
    async getApprovalFlowStatus() {
      this.xy.loading();
      let res = await xyapi.get(`${this.$store.state.apiPath}/api/ClassTableGenerateForTeacherApplyExamine/GetApprovalFlowStatus`);
      this.xy.unloading();
      if (res.success) {
        this.selectStatus = "";
        this.selectStatusId = 0;
        this.statusData = [];
        if(res.data.length>0){
          this.selectStatusId = res.data[0].ID;
          this.selectStatus = res.data[0].Name;
          res.data.map(item => {
            this.statusData.push({
              id: item.ID,
              name: item.Name
            });
          });
        }else{
          this.selectStatusId = -1
        }
        if(this.selectYearId!==0&&this.selectSessionId!==0){
          this.onRefresh();
        }else{
          this.applyList = [];
        }
      }
    },
    async loadList() {
      this.xy.loading();
      let res = await xyapi.get(`${this.$store.state.apiPath}/api/ClasstableGenerateForTeacherAdjustmentApply/GetMyTeaherApplyList`, {
        type: 0,
        academicYearID: this.selectYearId,
        academicSessionID: this.selectSessionId,
        state: this.selectStatusId,
        pageIndex: this.page,
        pageSize: this.pageSize
      });
      this.xy.unloading();
      if (res.success) {
        let list = res.data.data;
        this.applyList = [...this.applyList, ...list];
        this.loading = false;
        this.page++;
        this.finished =(this.applyList.length >= res.data.totalRecords) ? true : false;
      }
    },

    onRefresh() {
      setTimeout(() => {
        this.applyList = [];
        this.page = 1;
        this.isLoading = false;
        this.loadList();
      }, 500);
    }
  }
};
</script>
<style lang="less" scoped>
.choose {
  display: flex !important;
  margin: 8px 0;
  /deep/ .van-field__label {
    width: auto !important;
    margin-right: 16px !important;
    span {
      font-size: 28px !important;
    }
  }
  /deep/ .van-field__body {
    input {
      font-size: 28px !important;
    }
  }
}
.approval-ul {
  margin: 10px 19px;
  .approval-li {
    margin-bottom: 16px;
    height: 220px;
    background: #fff;
    box-shadow: 0px 2px 21px 0px rgba(197, 197, 197, 0.5);
    border-radius: 6px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .class-name {
      font-size: 28px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 10px;
      max-width: 90%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .effective-week {
      font-size: 24px;
      display: inline-block;
      padding: 8px 30px 7px 11px;
      color: #8a8a8a;
      background: #f6f6f7;
      border-radius: 16px 0px 16px 0px;
      margin-bottom: 10px;
    }
    .adjust-type {
      font-size: 22px;
      color: #8a8a8a;
      margin-bottom: 10px;
    }


    .img-photo {
      width:64px;
      height:64px;
      border-radius:50%;
    }
    .status-type{
      flex:1;
      text-align: right;
    }
  }
}
</style>
